// extracted by mini-css-extract-plugin
export default {"topic":"topic_topic__XCbJp","title":"topic_title__GfyQI"};